import { useEffect, useMemo, useState } from "react";
import ResponsiveAppBar from "../../../../layouts/navbar";
import { Footer } from "../../../../layouts/footer";
import { useAppDispatch, useAppSelector } from "../../../../../app/redux/hooks";
import { getShopListAsync } from "../../../../../app/slices/footerSlice/footerSlice";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { GoogleMapSelector } from "../../../private/profilePage/components/address/GoogleMapSelector";
import { useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";

export const StoreLocations = () => {
  const dispatch = useAppDispatch();
  const [shopData, setShopData] = useState<any[]>([]);
  const [selectedStoreIndex, setSelectedStoreIndex] = useState<number | null>(
    null
  ); // Track selected store index
  const [currentLocation, setCurrentLocation] = useState<
    google.maps.LatLngLiteral | undefined
  >(undefined);
  const { storeId } = useParams();
  // Define map container style
  const containerStyle = {
    width: "100%",
    height: "500px",
    border: "1px solid grey", // Debugging border
  };
  const isLoading = useAppSelector(
    (state) => state.FooterDataState.shopData.loader
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    dispatch(getShopListAsync()).then((response: any) => {
      const data = response?.payload?.data;
      setShopData(data?.shops || []);

      if (data?.shops && data.shops.length > 0) {
        let selectedIndex = 0;
        let lat = 0;
        let lng = 0;

        // Try to find the store by ID from the URL
        if (storeId) {
          const foundIndex = data.shops.findIndex(
            (store: any) => String(store.uuid) === String(storeId)
          );
          if (foundIndex !== -1) {
            selectedIndex = foundIndex;
            lat = Number(data.shops[foundIndex].latitude);
            lng = Number(data.shops[foundIndex].longitude);
          }
        } else {
          lat = Number(data.shops[0].latitude);
          lng = Number(data.shops[0].longitude);
        }

        if (!isNaN(lat) && !isNaN(lng)) {
          setSelectedStoreIndex(selectedIndex);
          setCurrentLocation({ lat, lng });
        }
      }
    });
  }, [dispatch, storeId]);

  // useEffect(() => {
  //   dispatch(getShopListAsync()).then((response: any) => {
  //     const data = response?.payload?.data;
  //     setShopData(data?.shops);

  //     // Ensure we have a valid first store to set as the initial location
  //     if (data?.shops && data.shops.length > 0) {
  //       const firstStore = data.shops[0];
  //       // Check for valid latitude and longitude before setting
  //       const lat = Number(firstStore.latitude);
  //       const lng = Number(firstStore.longitude);
  //       if (!isNaN(lat) && !isNaN(lng)) {
  //         setSelectedStoreIndex(0);
  //         setCurrentLocation({ lat, lng });
  //       }
  //     }
  //   });
  // }, [dispatch]);

  // Handle store selection and update map center
  const handleStoreClick = (store: any, index: number) => {
    const lat = Number(store.latitude);
    const lng = Number(store.longitude);

    // Check for valid latitude and longitude before setting
    if (!isNaN(lat) && !isNaN(lng)) {
      setSelectedStoreIndex(index);
      setCurrentLocation({ lat, lng });
    }
  };

  return (
    <>
      <ResponsiveAppBar />
      <div
        id="wrapper"
        style={{
          fontFamily: "Albert Sans, sans-serif",
          fontSize: "14px",
          lineHeight: "22px",
          fontWeight: "400",
        }}
      >
        <h3 className="fs-22 fw-6 text-center mt-5">
          Navya Bakeshop Locations
        </h3>
        <section className="flat-spacing-16 pt-4">
          <div className="container">
            {isLoading ? (
              <div className="row widget-tabs" style={{ minHeight: "50vh" }}>
                <div className="col-xl-4 col-md-5 col-12">
                  <div className="tf-store-list d-flex gap-10 flex-column widget-menu-tab">
                    <CircularProgress
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="row widget-tabs">
                <div className="col-xl-4 col-md-5 col-12">
                  <div
                    className="tf-store-list d-flex gap-10 flex-column widget-menu-tab"
                    style={{ height: "500px", overflowY: "scroll" }}
                  >
                    {shopData.map((store: any, index: number) => (
                      <div
                        key={index}
                        className="tf-store-item item-title default"
                        style={{
                          backgroundColor:
                            selectedStoreIndex === index ? "black" : "",
                          color:
                            selectedStoreIndex === index ? "white" : "black",
                          cursor: "pointer",
                          padding: "10px", // Adding padding for better UI
                          marginBottom: "10px", // Space between items
                          borderRadius: "5px",
                        }}
                        onClick={() => handleStoreClick(store, index)} // Handle click on store
                      >
                        <h6
                          className="tf-store-title"
                          style={{
                            backgroundColor:
                              selectedStoreIndex === index ? "black" : "",
                            color:
                              selectedStoreIndex === index ? "white" : "black",
                          }}
                        >
                          <div className="icon">
                            <i className="icon-place"></i>
                          </div>
                          {store.unit_name}
                        </h6>
                        <div className="tf-store-info">
                          <span>Address</span>
                          <p>
                            {store.address.street}, {store.address.city},{" "}
                            {store.address.district},{" "}
                            {store.address.state_or_province},{" "}
                            {store.address.pin_code}
                          </p>
                        </div>
                        <div className="tf-store-info">
                          <span>Phone</span>
                          <p>{store.contact_no}</p>
                        </div>
                        <div className="tf-store-info">
                          <span>Email</span>
                          <p>{store.email}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="col-xl-8 col-md-7 col-12">
                  <div>
                    <div className="widget-content-inner p-0">
                      {/* {currentLocation && ( */}
                      <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={currentLocation}
                        // key={`${10.0158605},${76.3418666}`}
                        zoom={14}
                        options={{
                          disableDefaultUI: true,
                          zoomControl: true,
                          streetViewControl: true,
                          fullscreenControl: true,
                          mapTypeId: "roadmap",
                        }}
                      >
                        {currentLocation && (
                          <Marker position={currentLocation} />
                        )}
                      </GoogleMap>
                      {/* )} */}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};
